import React from 'react';

const BundleTiers = ({ bundles, selectedBundle, onSelectBundle, onPreviewBundle, teamPrimaryColor }) => {
    if (!bundles || bundles.length === 0) {
        return null;
    }

    const calculateBundleTotal = (bundle) => {
        // Calculate total from bundle entries (no fallback to minimumAmount since it's now calculated)
        return bundle.optionBundleEntries?.reduce((total, entry) => {
            return total + (entry.itemsOption?.price || 0) * entry.quantity;
        }, 0) || 0;
    };

    return (
        <div className="bundle-tiers-container">
            <h3 style={{ color: teamPrimaryColor || '#0e456c', marginBottom: '1.5rem' }}>
                Make Your Impact
            </h3>
            <h4 className="mb-3" style={{ color: teamPrimaryColor || '#0e456c' }}>
                Choose Your Sponsorship Level
            </h4>
            <p className="text-muted mb-4">
                Select a sponsorship level to make your impact, or choose "Custom Purchase" below to pick individual items.
            </p>
            <div className="row g-2">
                {bundles
                    .sort((a, b) => calculateBundleTotal(b) - calculateBundleTotal(a)) // Sort highest to lowest price
                    .map((bundle) => {
                    const isSelected = selectedBundle?.id === bundle.id;
                    const bundleTotal = calculateBundleTotal(bundle);
                    
                    return (
                        <div key={bundle.id} className="col-6 col-md-4 col-lg-3">
                            <div 
                                className={`bundle-tier-card ${isSelected ? 'selected' : ''}`}
                                style={{
                                    border: '2px solid',
                                    borderColor: isSelected ? (teamPrimaryColor || '#0e456c') : '#dee2e6',
                                    borderRadius: '8px',
                                    padding: window.innerWidth < 768 ? '12px 10px' : '16px 14px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: isSelected ? (teamPrimaryColor ? `${teamPrimaryColor}15` : '#f0f7ff') : 'white',
                                    boxShadow: isSelected ? '0 4px 8px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)',
                                    position: 'relative',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div>
                                    <div style={{ 
                                        fontSize: window.innerWidth < 768 ? '1.5em' : '2em',
                                        marginBottom: window.innerWidth < 768 ? '8px' : '12px' 
                                    }}>
                                        {bundle.icon || '🎁'}
                                    </div>
                                    <h6 style={{ 
                                        color: teamPrimaryColor || '#0e456c', 
                                        marginBottom: window.innerWidth < 768 ? '6px' : '10px',
                                        fontSize: window.innerWidth < 768 ? '1rem' : '1.1rem',
                                        fontWeight: 'bold'
                                    }}>
                                        ${bundleTotal}
                                    </h6>
                                    <p style={{ 
                                        margin: 0, 
                                        marginBottom: window.innerWidth < 768 ? '4px' : '6px',
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        fontSize: window.innerWidth < 768 ? '0.8rem' : '0.9rem',
                                        lineHeight: window.innerWidth < 768 ? '1.2' : '1.3'
                                    }}>
                                        {bundle.name}
                                    </p>
                                    {bundle.description && (
                                        <p style={{ 
                                            margin: 0, 
                                            marginBottom: window.innerWidth < 768 ? '8px' : '12px',
                                            fontSize: window.innerWidth < 768 ? '0.7rem' : '0.75rem',
                                            lineHeight: window.innerWidth < 768 ? '1.2' : '1.3',
                                            color: '#6c757d',
                                            fontStyle: 'italic'
                                        }}>
                                            {bundle.description}
                                        </p>
                                    )}
                                </div>
                                
                                <div>
                                  
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm mt-2"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onPreviewBundle(bundle);
                                        }}
                                    >
                                        Preview
                                    </button>
                                </div>
                                
                                {isSelected && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        backgroundColor: teamPrimaryColor || '#0e456c',
                                        color: '#fff',
                                        borderRadius: '50%',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                        ✓
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BundleTiers;
